import { LoadingButton } from '@mui/lab';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Form, FormikProvider, useFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';

const SetWebhook = ({
  onCancel,
  onSubmit,
  webhook: { webhookSecret, webhookUrl },
  loading
}) => {
  const theme = useTheme();
  const helperTexts = {
    secret: 'Introduce el WEBHOOK SECRET',
    url: 'Introduce el WEBHOOK URL'
  };
  const validationSchema = Yup.object().shape({
    webhookSecret: Yup.string().required(helperTexts.secret),
    webhookUrl: Yup.string().required(helperTexts.url)
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      webhookSecret: webhookSecret || '',
      webhookUrl: webhookUrl || ''
    },
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values);
    }
  });

  const { errors, values, touched, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid
          container
          columnSpacing={2}
          rowSpacing={2}
          justifyContent="center"
        >
          <Grid lg={6}>
            <Stack spacing={2}>
              <Typography color={theme.palette.grey[600]}>
                WEBHOOK SECRET
              </Typography>
              <TextField
                fullWidth
                label="Ej. MY_SECRET"
                value={values.webhookSecret}
                {...getFieldProps('webhookSecret')}
                required
                error={Boolean(touched.webhookSecret && errors.webhookSecret)}
                helperText={
                  (touched.webhookSecret && errors.webhookSecret) ||
                  helperTexts.secret
                }
              />
            </Stack>
          </Grid>
          <Grid lg={6}>
            <Stack spacing={2}>
              <Typography color={theme.palette.grey[600]}>
                WEBHOOK URL
              </Typography>
              <TextField
                fullWidth
                label="Ej. www.example.com"
                value={values.webhookUrl}
                {...getFieldProps('webhookUrl')}
                required
                error={Boolean(touched.webhookUrl && errors.webhookUrl)}
                helperText={
                  (touched.webhookUrl && errors.webhookUrl) || helperTexts.url
                }
              />
            </Stack>
          </Grid>
          <Grid lg={12}>
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button color="error" variant="outlined" onClick={onCancel}>
                Cancelar
              </Button>
              <LoadingButton type="submit" variant="contained" {...{ loading }}>
                Guardar
              </LoadingButton>
            </Stack>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
};

SetWebhook.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  webhook: PropTypes.shape({
    webhookUrl: PropTypes.string,
    webhookSecret: PropTypes.string
  }),
  loading: PropTypes.func
};

export default SetWebhook;
